import { omitBy, isUndefined } from 'lodash';

const getKey = () => performance.now().toFixed(3);

export function useBrowserHistory() {
    // like in Vue Router
    let lastState = history.state;

    return {
        pushState: (state = {}, url = null) => {
            state = omitBy(
                {
                    [Symbol.for('source')]: 'useBrowserHistory',
                    key: getKey(),
                    ...state
                },
                isUndefined
            );
            history.pushState(state, '', url);
            lastState = state;
        },
        replaceState: (state = {}, url = null) => {
            state = omitBy(
                {
                    key: getKey(),
                    ...history.state,
                    ...state
                },
                isUndefined
            );

            history.replaceState(state, '', url);
            lastState = state;
        },
        go: (n) => {
            history.go(n);
        },
        back: () => {
            history.back();
        },
        forward: () => {
            history.forward();
        },
        onPopState: (callback, options = {}) => {
            const abortController = new AbortController();
            const dispose = () => {
                abortController.abort();
            };
            const onPopState = (event) => {
                const { state } = event;
                const isBack = state == null
                    ? true
                    : lastState == null
                        ? false
                        : Number(state.key) < Number(lastState.key);
                lastState = state;
                callback(event, { isBack, isForward: !isBack });
            };
            window.addEventListener('popstate', onPopState, { signal: abortController.signal, ...options });

            return dispose;
        },
        getCurrentState: () => history.state
    };
}
